import { Outlet } from "react-router-dom";
import MainContent from "./components/Body/body";
import Header from "./components/Header/HeaderComponent";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

export default function Layout() {
    return (
      <I18nextProvider i18n={i18n}>
        <div>
            <Header />
            <MainContent />
            <Outlet/>
        </div>
    </I18nextProvider>
    )
}